/* assets/glg-route-intent.js — GLG-ROUTE-CONTACT-RUNTIME-09 (ACETERNITY UI ALIGNED)
 * Owners:
 * - [data-glg-route-intent-section]: visibility and City +1 referral metrics.
 * - [data-contact-root]: query-driven Support / Project / Property Contact mode and choice synchronization.
 * HTML owners: snippets/glg-route-intent.liquid and snippets/littleg-opening-enquiry.liquid.
 */
(function () {
  'use strict';

  var VERSION = 'GLG-ROUTE-CONTACT-RUNTIME-11';
  if (window.__GLG_ROUTE_INTENT_RUNTIME__ === VERSION) return;
  window.__GLG_ROUTE_INTENT_RUNTIME__ = VERSION;

  var ROUTE_ROOT_SELECTOR = '[data-glg-route-intent-section]';
  var CONTACT_ROOT_SELECTOR = '[data-contact-root]';
  var REFERRAL_STORAGE_KEY = 'littleg_city_plus_one_referral_latest_v1';
  var GCP_BRIEF_STORAGE_KEY = 'gcitypartners_review_brief_draft_v1';

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function emit(name, detail) {
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (_) {}
  }

  function readParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (_) {
      return new URLSearchParams();
    }
  }

  function opaque(value) {
    var text = clean(value);
    return /^[A-Za-z0-9._:-]{1,160}$/.test(text) ? text : '';
  }

  function gcpDraftRows(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'object' && Array.isArray(value.items)) {
      return value.items;
    }
    return [];
  }

  function readGCityPartnersBrief(recordId) {
    var safeRecordId = opaque(recordId);
    if (!safeRecordId) return null;

    var stores = [];
    try { stores.push(window.localStorage); } catch (_) {}
    try { stores.push(window.sessionStorage); } catch (_) {}

    for (var storeIndex = 0; storeIndex < stores.length; storeIndex += 1) {
      var raw = '';
      try {
        raw = stores[storeIndex].getItem(GCP_BRIEF_STORAGE_KEY) || '';
      } catch (_) { raw = ''; }

      if (!raw) continue;
      var parsed = null;
      try { parsed = JSON.parse(raw); } catch (_) { parsed = null; }

      var rows = gcpDraftRows(parsed);
      for (var rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
        var row = rows[rowIndex];
        if (row && opaque(row.record_id) === safeRecordId) {
          return row;
        }
      }
    }
    return null;
  }

  function gcpBriefSummary(draft) {
    if (!draft) return '';
    var resourceGoals = clean(draft.resource_goals).replace(/\|/g, '、');

    var rows = [
      ['Record ID', opaque(draft.record_id)],
      ['項目地點', clean(draft.project_location)],
      ['目前階段', clean(draft.project_stage)],
      ['能力方向', clean(draft.service_lane)],
      ['需求類型', clean(draft.business_need)],
      ['資源方向', clean(draft.resource_mode)],
      ['資源類型', clean(draft.resource_type)],
      ['合作目標', resourceGoals],
      ['預檢完備度', clean(draft.precheck_score) ? clean(draft.precheck_score) + '%' : ''],
      ['預檢目的', clean(draft.precheck_purpose)],
      ['圖資狀態', clean(draft.precheck_evidence).replace(/\|/g, ' · ')],
      ['建議補齊', clean(draft.precheck_recommendations).replace(/\|/g, ' · ')],
      ['圖資存取連結', clean(draft.asset_access_link)],
      ['GSD / 精度', clean(draft.gsd_requirement)],
      ['期望時間', clean(draft.project_timeline)],
      ['預算範圍', clean(draft.budget_range)],
      ['來源', clean(draft.source_context)],
      ['來源項目', clean(draft.source_card_id)],
      ['希望成果', clean(draft.desired_outcome).slice(0, 800)],
      ['項目情況', clean(draft.observation).slice(0, 1200)]
    ];

    return rows
      .filter(function (row) { return Boolean(row[1]); })
      .map(function (row) { return row[0] + '：' + row[1]; })
      .join('\n');
  }

  function contactStageForBrief(draft) {
    var lane = clean(draft && draft.service_lane).toLowerCase();
    if (/property|valuation|asset/.test(lane)) return 'valuation';
    if (/urban-renewal|land|planning/.test(lane)) return 'planning';
    if (/infrastructure|survey|spatial/.test(lane)) return 'survey';
    if (/digital|technology/.test(lane)) return 'digital';
    if (/water|green|industry/.test(lane)) return 'delivery';
    return 'unknown';
  }

  function hydrateGCityPartnersBriefContext(root, context) {
    if (!root || !context || context.source !== 'gcitypartners-review-brief') {
      return null;
    }
    var draft = readGCityPartnersBrief(context.recordId);
    if (!draft) {
      root.setAttribute('data-gcp-brief-handoff-state', 'local-draft-not-found');
      return null;
    }

    var record = root.querySelector('[data-contact-record-id]');
    var projectLocation = root.querySelector('[name="contact[project_location]"]');
    var subject = root.querySelector('[data-contact-subject]');
    var body = root.querySelector('[data-contact-body]');
    var summaryBox = root.querySelector('[data-contact-brief-summary]');
    var summaryCopy = root.querySelector('[data-contact-brief-summary-copy]');
    var summary = gcpBriefSummary(draft);

    if (record) record.value = opaque(draft.record_id);
    if (projectLocation) {
      const previousGenerated =
        projectLocation.dataset.gcpBriefGeneratedValue;

      if (
        !clean(projectLocation.value) ||
        (
          previousGenerated !== undefined &&
          projectLocation.value === previousGenerated
        )
      ) {
        projectLocation.value = clean(draft.project_location);
        projectLocation.dataset.gcpBriefGeneratedValue =
          projectLocation.value;
      }
    }
    if (subject && !clean(subject.value)) {
      subject.value = 'GCityPartners 項目簡報｜' + (
        clean(draft.project_location) ||
        clean(draft.service_lane) ||
        opaque(draft.record_id)
      );
    }
    if (body && summary) {
      const previousGenerated = body.dataset.gcpBriefGeneratedValue;

      if (
        !clean(body.value) ||
        (
          previousGenerated !== undefined &&
          body.value === previousGenerated
        )
      ) {
        body.value = summary;
        body.dataset.gcpBriefGeneratedValue = body.value;
      }
    }
    if (summaryBox && summaryCopy && summary) {
      summaryCopy.textContent = summary.replace(/\n/g, ' · ');
      summaryBox.hidden = false;
    }

    context.scenario = context.scenario || clean(draft.service_lane);
    context.requestedStage = context.requestedStage || contactStageForBrief(draft);
    root.setAttribute('data-gcp-brief-handoff-state', 'local-draft-hydrated');
    return draft;
  }

  function localeWords(zhHans, zhHant, en) {
    var lang = clean(document.documentElement && document.documentElement.lang).toLowerCase();
    if (lang === 'zh-cn' || lang === 'zh-hans' || lang === 'zh-sg') return zhHans;
    if (lang.indexOf('zh') === 0) return zhHant;
    return en;
  }

  function streamlineUavProjectContact(root, draft) {
    if (!root || !draft || draft.precheck_type !== 'uav-3d') return false;

    root.setAttribute('data-gcp-uav-handoff', 'true');

    var serviceChoice = root.querySelector('[data-contact-service-choice]');
    var detailFields = root.querySelector('[data-contact-project-detail-fields]');
    if (serviceChoice) serviceChoice.hidden = true;
    if (detailFields) detailFields.hidden = true;

    setContactText(
      root,
      '[data-contact-eyebrow]',
      localeWords('GCITYPARTNERS · 项目咨询', 'GCITYPARTNERS · 項目諮詢', 'GCITYPARTNERS · PROJECT ENQUIRY')
    );
    setContactText(
      root,
      '[data-contact-title]',
      localeWords('航测与 3D 建模项目咨询', '航測與 3D 建模項目諮詢', 'Drone Survey & 3D Modeling Enquiry')
    );
    setContactText(
      root,
      '[data-contact-description]',
      localeWords(
        '预检与项目资料已载入。这里只补充公司及联系资料，然后明确提交给 GLG。',
        '預檢與項目資料已載入。這裡只補充公司及聯絡資料，然後明確提交給 GLG。',
        'Your precheck and project details are loaded. Add company and contact details only, then submit explicitly to GLG.'
      )
    );
    setContactText(
      root,
      '[data-contact-submit]',
      localeWords('提交项目咨询', '提交項目諮詢', 'Send Project Enquiry')
    );

    var firstLegend = root.querySelector('.contact-portal__fieldset .contact-portal__legend');
    if (firstLegend) {
      firstLegend.textContent = localeWords('联系资料', '聯絡資料', 'Contact details');
    }

    return true;
  }

  function readPropertyDraft() {
    var gate = window.GPROPERTY_DATA_GATE;
    if (!gate || typeof gate.readPropertyDraft !== 'function') return null;
    var stored = gate.readPropertyDraft(gate.canonicalDraftKey, gate.legacyDraftKey);
    return stored && stored.draft ? stored.draft : null;
  }

  function hydratePropertyContext(root, context) {
    if (!context.propertyMode) return;
    var gate = window.GPROPERTY_DATA_GATE;
    var draft = readPropertyDraft();
    var requested = opaque(context.recordId);
    var draftRecord = opaque(draft && draft.record_id);

    if (requested && requested !== draftRecord) {
      draft = null;
      draftRecord = '';
    }

    var record = root.querySelector('[data-contact-record-id]');
    var location = root.querySelector('[name="contact[project_location]"]');
    var subject = root.querySelector('[data-contact-subject]');
    var body = root.querySelector('[data-contact-body]');
    var consent = root.querySelector('[data-contact-property-consent]');

    if (record) record.value = draftRecord || '';
    if (consent) consent.required = true;

    if (!draft || !gate) return;

    var estate = draft.estate_context || {};
    var label = gate.locationLabel(estate) || gate.clean(draft.project_location);

    if (location && !clean(location.value)) {
      location.value = label;
    }
    if (subject && !clean(subject.value)) {
      subject.value = 'GLHK 物業服務｜人工核實';
    }
    if (body && !clean(body.value)) {
      body.value = [
        label ? '物業／地點：' + label : '',
        draftRecord ? 'Record ID：' + draftRecord : '',
        '需要協助：'
      ].filter(Boolean).join('\n');
    }

    root.setAttribute('data-property-context-state', 'local-draft-hydrated');
  }

  function writeReferral(payload) {
    try {
      localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(payload));
      return 'localStorage';
    } catch (_) {
      try {
        sessionStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(payload));
        return 'sessionStorage';
      } catch (_) {
        return '';
      }
    }
  }

  function setRouteVisible(root, visible) {
    root.hidden = !visible;
    root.setAttribute('aria-hidden', visible ? 'false' : 'true');
    root.setAttribute('data-route-return-ready', visible ? 'true' : 'false');
  }

  function bindStartMetric(root, payload) {
    toArray(root.querySelectorAll('[data-route-intent-action="start-city-plus-one"]')).forEach(function (link) {
      if (link.getAttribute('data-route-intent-metric-bound') === VERSION) return;
      link.setAttribute('data-route-intent-metric-bound', VERSION);
      link.addEventListener('click', function () {
        emit('littleg:city-plus-one:metric', {
          name: 'referral_start',
          payload: payload,
          source: 'friend-return'
        });
        emit('littleg:city-plus-one:referral-start', payload);
      });
    });
  }

  function mountRouteIntent(root) {
    if (!root || root.getAttribute('data-route-intent-runtime-ready') === VERSION) return;
    root.setAttribute('data-route-intent-runtime-ready', VERSION);
    root.setAttribute('data-route-intent-runtime-owner', 'assets/glg-route-intent.js');

    var intent = clean(root.getAttribute('data-route-intent')).toLowerCase();
    var isCityPlusOne = intent === 'city-plus-one' || intent === 'city_plus_one';

    if (!isCityPlusOne) {
      setRouteVisible(root, true);
      return;
    }

    var params = readParams();
    var isShareReturn = params.get('mission') === 'city-plus-one' || params.get('from') === 'share';
    if (!isShareReturn) {
      setRouteVisible(root, false);
      return;
    }

    var payload = {
      source: 'city-plus-one',
      eventSource: 'friend-return',
      mission: params.get('mission') || 'city-plus-one',
      theme: params.get('theme') || 'general',
      ref: params.get('ref') || '',
      cardId: params.get('cardId') || '',
      from: params.get('from') || 'share',
      openedAt: new Date().toISOString()
    };

    setRouteVisible(root, true);
    root.setAttribute('data-route-referral-storage', writeReferral(payload) || 'unavailable');
    bindStartMetric(root, payload);

    emit('littleg:city-plus-one:metric', {
      name: 'referral_open',
      payload: payload,
      source: 'friend-return'
    });
    emit('littleg:city-plus-one:referral-open', payload);
  }

  function setContactText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function contactChoiceSets() {
    return {
      support: [
        { key: 'usage', label: '產品與使用', value: 'LittleG 產品使用問題', subject: '產品與使用查詢' },
        { key: 'account', label: '帳戶與登入', value: '帳戶與登入權限', subject: '帳戶或登入問題' },
        { key: 'order', label: '付款與訂閱', value: '訂單、付款與賬單查詢', subject: '賬單與訂閱查詢' },
        { key: 'privacy', label: '私隱與資料', value: '隱私與個人資料查詢', subject: '隱私與資料安全查詢' },
        { key: 'other', label: '技術支援', value: '其他技術支援服務', subject: '其他技術支援查詢' },
        { key: 'follow-up', label: '個案跟進', value: '需要正式團隊跟進', subject: '工單跟進與專人回覆' }
      ],
      project: [
        { key: 'survey', label: '前期摸查', value: '前期摸查與可行性判斷', subject: '項目諮詢｜前期摸查與可行性' },
        { key: 'valuation', label: '價值判斷', value: '資產價值與投資判斷', subject: '項目諮詢｜資產與價值判斷' },
        { key: 'planning', label: '規劃審批', value: '城市規劃與報批支援', subject: '項目諮詢｜規劃與審批支援' },
        { key: 'delivery', label: '交付實施', value: '項目實施與落地支撐', subject: '項目諮詢｜交付與實施支撐' },
        { key: 'digital', label: '數字平台', value: '數字化平台與空間方案', subject: '項目諮詢｜數字平台方案' },
        { key: 'unknown', label: '綜合諮詢', value: '尚未確定（綜合評估）', subject: '項目諮詢｜綜合需求評估' }
      ],
      property: [
        { key: 'manual-verification', label: '人工核實', value: '物業資料人工核實', subject: 'GLHK 物業服務｜人工數據核實' },
        { key: 'buyer', label: '買樓分析', value: '買樓比較與物業判斷', subject: 'GLHK 物業服務｜買樓比較分析' },
        { key: 'viewing', label: '睇樓安排', value: '實地睇樓與現場勘查', subject: 'GLHK 物業服務｜實地睇樓安排' },
        { key: 'sale', label: '業主放售', value: '業主物業放售服務', subject: 'GLHK 物業服務｜業主放售' },
        { key: 'lease', label: '業主放租', value: '業主物業放租服務', subject: 'GLHK 物業服務｜業主放租' },
        { key: 'other', label: '其他服務', value: '其他專屬物業需求', subject: 'GLHK 物業服務｜其他需求' }
      ]
    };
  }

  function setContactModeContent(root, projectMode, propertyMode, context) {
    root.setAttribute(
      'data-contact-mode',
      propertyMode ? 'property' : (projectMode ? 'project' : 'support')
    );

    toArray(root.querySelectorAll('[data-contact-project-only]')).forEach(function (node) {
      node.hidden = !(projectMode || propertyMode);
    });

    toArray(root.querySelectorAll('[data-contact-property-only]')).forEach(function (node) {
      node.hidden = !propertyMode;
    });

    var consent = root.querySelector('[data-contact-property-consent]');
    if (consent) consent.required = propertyMode;

    toArray(root.querySelectorAll('form.a11y-form-errors, form[data-a11y-form-errors]')).forEach(function (form) {
      form.dispatchEvent(new CustomEvent('contact:mode-change'));
    });

    [
      ['[data-contact-source]', context.source],
      ['[data-contact-intent]', context.intent],
      ['[data-contact-scenario]', context.scenario],
      ['[data-contact-service-lane]', context.serviceLane],
      ['[data-contact-case]', context.caseId]
    ].forEach(function (entry) {
      var node = root.querySelector(entry[0]);
      if (node) node.value = entry[1];
    });
    var record = root.querySelector('[data-contact-record-id]');
    if (record) record.value = context.recordId;

    // Reconcile existing shared form labels when a Contact URL selects Project or Property.
    // This changes presentation only; native input names and posted_successfully? stay Shopify-owned.
    if (projectMode || propertyMode) {
      var modeLocale = String(document.documentElement.lang || '').toLowerCase();
      var modeHans = /^zh-(cn|hans|sg)(?:-|$)/.test(modeLocale);
      var modeZh = /^zh(?:-|$)/.test(modeLocale);
      var modeText = function (traditional, simplified, english) {
        return modeHans ? simplified : (modeZh ? traditional : english);
      };
      var modeLabel = propertyMode
        ? modeText('物業需求詳情', '物业需求详情', 'Property Enquiry Details')
        : modeText('項目說明', '项目说明', 'Project Description');
      var message = root.querySelector('[data-contact-body]');
      if (message) {
        var messageLabel = root.querySelector('label[for="' + message.id + '"]');
        if (messageLabel) messageLabel.textContent = modeLabel;
      }
      var detailLegend = root.querySelector('[data-contact-project-detail-fields] .contact-portal__legend');
      if (detailLegend) detailLegend.textContent = modeLabel;
      var consentLabel = root.querySelector('.contact-portal__consent span');
      if (consentLabel && consentLabel.firstChild && consentLabel.firstChild.nodeType === 3) {
        consentLabel.firstChild.nodeValue = propertyMode
          ? modeText('我同意就本次物業需求與我聯絡，詳情請參閱 ', '我同意就本次物业需求与我联系，详情请参阅 ', 'I agree to be contacted about this property enquiry, as described in the ')
          : modeText('我同意就本次項目諮詢與我聯絡，詳情請參閱 ', '我同意就本次项目咨询与我联系，详情请参阅 ', 'I agree to be contacted about this project enquiry, as described in the ');
      }
      var successBox = root.querySelector('[data-contact-submission-success]');
      if (successBox) {
        var successHeading = successBox.querySelector('strong');
        var successMessage = successBox.querySelector('p');
        if (successHeading) successHeading.textContent = propertyMode
          ? modeText('物業查詢已送出', '物业咨询已提交', 'Property Enquiry Sent')
          : modeText('項目查詢已送出', '项目咨询已提交', 'Project Enquiry Sent');
        if (successMessage) successMessage.textContent = modeText('已收到你的查詢，請留意電郵回覆。', '已收到你的咨询，请留意邮件回复。', 'Your enquiry has been received. Please check your email for a reply.');
      }
    }

    // --- PROPERTY MODE ---
    if (propertyMode) {
      setContactText(root, '[data-contact-eyebrow]', 'GLHK PROPERTY SERVICES');
      setContactText(root, '[data-contact-title]', localeWords('联系物业服务团队', '聯絡物業服務團隊', 'Contact Property Services'));
      setContactText(root, '[data-contact-description]', localeWords('选择物业服务需求，我们会按查询内容安排跟进。', '選擇物業服務需求，我們會按查詢內容安排跟進。', 'Select the property service you need. We will review your enquiry and follow up as appropriate.'));
      setContactText(root, '[data-contact-context-kicker]', 'INQUIRY TYPE');
      setContactText(root, '[data-contact-context-title]', localeWords('选择服务类别', '選擇服務類別', 'Choose a Service'));
      setContactText(root, '[data-contact-trust-one]', localeWords('我们会根据物业需求跟进。', '我們會按物業需求安排跟進。', 'We will review your property enquiry.'));
      setContactText(root, '[data-contact-trust-two]', localeWords('物业资料可申请人工核实', '物業資料可申請人工核實', 'Request property information verification'));
      setContactText(root, '[data-contact-trust-three]', localeWords('个人资料按隐私政策处理', '個人資料按私隱政策處理', 'Personal data handled under the Privacy Policy'));
      setContactText(root, '[data-contact-helper]', localeWords('请提供物业名称、地点、当前情况及希望获得的协助。', '請提供物業名稱、地點、現況及希望獲得的協助。', 'Include the property name, location, current situation and assistance required.'));
      setContactText(root, '[data-contact-submit]', localeWords('提交物业咨询', '送出物業查詢', 'Send Property Enquiry'));

      var propertySubject = root.querySelector('[data-contact-subject]');
      var propertyBody = root.querySelector('[data-contact-body]');
      if (propertySubject) propertySubject.placeholder = localeWords('例如：物业比较与看房安排', '例如：物業比較與睇樓安排', 'e.g. Property comparison and viewing enquiry');
      if (propertyBody) propertyBody.placeholder = localeWords('请简述物业现况、目标及具体需求…', '請簡述物業現況、目標及具體需求…', 'Describe the property, your goals and assistance required…');
      return;
    }

    // --- SUPPORT MODE ---
    if (!projectMode) {
      var locale = String(document.documentElement.lang || '').toLowerCase();
      var hans = /^zh-(cn|hans|sg)(?:-|$)/.test(locale);
      var zh = /^zh(?:-|$)/.test(locale);
      var localized = function (traditional, simplified, english) {
        return hans ? simplified : (zh ? traditional : english);
      };
      var supportCopy = [
        ['[data-contact-eyebrow]', '客戶支援', '客户支持', 'CUSTOMER SUPPORT'],
        ['[data-contact-title]', '需要協助？', '需要帮助？', 'How Can We Help?'],
        ['[data-contact-description]', '有關平台使用、帳戶、付款或資料問題，歡迎聯絡我們。', '如有平台使用、账户、付款或数据问题，欢迎联系我们。', 'Get help with the platform, your account, billing or data enquiries.'],
        ['[data-contact-context-kicker]', '客戶支援', '客户支持', 'CUSTOMER SUPPORT'],
        ['[data-contact-context-title]', '需要哪方面的協助？', '需要哪方面的帮助？', 'What Do You Need Help With?'],
        ['[data-contact-trust-one]', '我們會按查詢內容安排跟進。', '我们会根据咨询内容安排跟进。', "We'll review your enquiry and respond as appropriate."],
        ['[data-contact-trust-two]', '電郵我們', '发送邮件', 'Email Us'],
        ['[data-contact-helper]', '請描述問題，並提供相關頁面連結或錯誤訊息。', '请描述问题，并提供相关页面链接或错误信息。', 'Describe your enquiry and include any relevant page links or error messages.'],
        ['[data-contact-submit]', '送出查詢', '提交咨询', 'Send Enquiry'],
        ['[data-contact-map-pin]', '電郵我們', '发送邮件', 'Email Us'],
        ['[data-contact-whatsapp]', 'WhatsApp 聯絡', 'WhatsApp 联系', 'Contact via WhatsApp']
      ];
      supportCopy.forEach(function (entry) {
        setContactText(root, entry[0], localized(entry[1], entry[2], entry[3]));
      });
      var supportSubject = root.querySelector('[data-contact-subject]');
      var supportBody = root.querySelector('[data-contact-body]');
      if (supportSubject) supportSubject.placeholder = localized('例如：無法登入帳戶', '例如：无法登录账户', 'e.g. Unable to Sign In');
      if (supportBody) supportBody.placeholder = localized('請描述你遇到的問題…', '请描述你遇到的问题…', "Describe the issue you're experiencing…");
      return;
    }

    // --- PROJECT MODE ---
    setContactText(root, '[data-contact-eyebrow]', 'GLG PROJECT ENQUIRIES');
    setContactText(root, '[data-contact-title]', localeWords('填写项目需求', '填寫項目需求', 'Prepare Project Brief'));
    setContactText(root, '[data-contact-description]', localeWords('请提供项目背景和需求。提交此表单仅发送项目咨询，不会创建正式项目。', '請提供項目背景與需求。提交此表單僅發送項目諮詢，不會建立正式 Project。', 'Share your project requirements. Submitting this form sends an enquiry; it does not create a formal Project.'));
    setContactText(root, '[data-contact-context-kicker]', 'SERVICE LANE');
    setContactText(root, '[data-contact-context-title]', localeWords('选择项目服务方向', '選擇項目服務方向', 'Choose a Project Service'));
    setContactText(root, '[data-contact-trust-one]', localeWords('我们会根据项目内容跟进。', '我們會按項目內容安排跟進。', 'We will review your project enquiry.'));
    setContactText(root, '[data-contact-trust-two]', localeWords('项目咨询', '項目諮詢', 'Project Enquiry'));
    setContactText(root, '[data-contact-trust-three]', localeWords('提交不构成正式专业委托', '提交不構成正式專業委託', 'Enquiry does not establish a professional engagement'));
    setContactText(root, '[data-contact-helper]', localeWords('请提供项目地点、阶段、可用资料、时间要求及主要需求。', '請提供項目地點、階段、可用資料、時間要求及主要需求。', 'Include project location, stage, available information, timeline and primary requirements.'));
    setContactText(root, '[data-contact-submit]', localeWords('提交项目咨询', '提交項目諮詢', 'Send Project Enquiry'));

    var subject = root.querySelector('[data-contact-subject]');
    var body = root.querySelector('[data-contact-body]');
    if (subject) subject.placeholder = localeWords('例如：园区前期项目咨询', '例如：園區前期項目諮詢', 'e.g. Industrial park initial project enquiry');
    if (body) body.placeholder = localeWords('请描述项目背景、地点、目标及需求…', '請描述項目背景、地點、目標及需求…', 'Describe the project context, location, objectives and requirements…');
  }

  function supportChoiceLabel(item) {
    var locale = String(document.documentElement.lang || '').toLowerCase();
    var hans = /^zh-(cn|hans|sg)(?:-|$)/.test(locale);
    var zh = /^zh(?:-|$)/.test(locale);
    var labels = {
      usage: ['產品與使用', '产品与使用', 'Product & Usage'],
      account: ['帳戶與登入', '账户与登录', 'Account & Sign-In'],
      order: ['付款與訂閱', '付款与订阅', 'Billing & Subscriptions'],
      privacy: ['私隱與資料', '隐私与数据', 'Privacy & Data'],
      other: ['技術支援', '技术支持', 'Technical Support'],
      'follow-up': ['個案跟進', '个案跟进', 'Follow Up']
    };
    var options = item && labels[item.key];
    return options ? options[hans ? 1 : (zh ? 0 : 2)] : item.label;
  }

  function contactModeChoiceLabel(item, mode) {
    if (mode === 'support') return supportChoiceLabel(item);
    var labels = mode === 'project' ? {
      survey: ['前期摸查', '前期摸查', 'Initial Assessment'],
      valuation: ['价值判断', '價值判斷', 'Valuation'],
      planning: ['规划审批', '規劃審批', 'Planning & Approvals'],
      delivery: ['交付实施', '交付實施', 'Delivery'],
      digital: ['数字平台', '數字平台', 'Digital Platform'],
      unknown: ['综合咨询', '綜合諮詢', 'General Enquiry']
    } : {
      'manual-verification': ['人工核实', '人工核實', 'Manual Verification'],
      buyer: ['买房分析', '買樓分析', 'Buying Analysis'],
      viewing: ['看房安排', '睇樓安排', 'Property Viewing'],
      sale: ['业主放售', '業主放售', 'Sell Property'],
      lease: ['业主出租', '業主放租', 'Lease Property'],
      other: ['其他服务', '其他服務', 'Other Services']
    };
    var row = labels[item.key];
    return row ? localeWords(row[0], row[1], row[2]) : item.label;
  }

  function renderContactChoices(choices, items, categoryNode) {
    var isSupportSet = items && items[0] && items[0].key === 'usage';
    choices.forEach(function (button, index) {
      var item = items[index];
      if (!item) {
        button.hidden = true;
        return;
      }
      button.hidden = false;
      button.textContent = contactModeChoiceLabel(item, isSupportSet ? 'support' : (items[0].key === 'survey' ? 'project' : 'property'));
      button.setAttribute('data-contact-choice', item.key);
      button.setAttribute('data-contact-value', item.value);
      button.setAttribute('data-contact-subject-value', item.subject);
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });

    if (!categoryNode) return;
    if (categoryNode.tagName === 'SELECT') {
      categoryNode.textContent = '';
      items.forEach(function (item) {
        var option = document.createElement('option');
        option.value = item.value;
        option.textContent = contactModeChoiceLabel(item, isSupportSet ? 'support' : (items[0].key === 'survey' ? 'project' : 'property'));
        categoryNode.appendChild(option);
      });
    }
  }

  function supportWhatsAppNumber(root) {
    return clean(root.getAttribute('data-contact-whatsapp-number')).replace(/\D/g, '') || '85263673202';
  }

  function supportEmailAddress(root) {
    return clean(root.getAttribute('data-contact-email-address')) || 'support@glhksolution.com';
  }

  function activateContactChoice(root, choices, button, context, preserveSubject) {
    if (!button) return;
    choices.forEach(function (item) {
      var active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var key = button.getAttribute('data-contact-choice') || '';
    var value = button.getAttribute('data-contact-value') || clean(button.textContent);
    var subjectValue = button.getAttribute('data-contact-subject-value') || value;
    var categoryNode = root.querySelector('[data-contact-category]');
    var subject = root.querySelector('[data-contact-subject]');
    var stageInput = root.querySelector('[data-contact-selected-stage]');
    var whatsapp = root.querySelector('[data-contact-whatsapp]');

    if (stageInput) stageInput.value = key;
    if (categoryNode) categoryNode.value = value;
    
    if (subject) {
      // Keep the approved support example on initial mount. Category changes may
      // offer a contextual example without overwriting user-authored subject text.
      if (!context.projectMode && !context.propertyMode && preserveSubject && key === 'usage') {
        subject.placeholder = localeWords('例如：无法登录账户', '例如：無法登入帳戶', 'e.g. Unable to Sign In');
      } else {
        subject.placeholder = localeWords('例如：', '例如：', 'For example: ') + subjectValue;
      }
      if (!preserveSubject && !clean(subject.value)) {
        subject.value = subjectValue;
      }
    }

    var prefix = context.propertyMode
      ? '你好，我想諮詢 GLHK 物業服務：'
      : (context.projectMode ? '你好，我想提交項目需求：' : localeWords('你好，我想查询支援服务：', '你好，我想查詢支援服務：', 'Hello, I need help with: '));
    const messageCategory = (context.propertyMode || context.projectMode)
      ? value
      : (clean(button.textContent) || value);
    var message = prefix + messageCategory + localeWords('。', '。', '.');
    if (context.scenario) message += ' 場景：' + context.scenario + '。';
    if (context.caseId) message += ' 案例：' + context.caseId + '。';

    if (whatsapp) whatsapp.href = 'https://wa.me/' + supportWhatsAppNumber(root) + '?text=' + encodeURIComponent(message);
    toArray(root.querySelectorAll('[data-contact-email]')).forEach(function (emailNode) {
      emailNode.href = 'mailto:' + supportEmailAddress(root) + '?subject=' + encodeURIComponent(subjectValue);
    });
  }

  function mountContact(root) {
    if (!root || root.getAttribute('data-contact-runtime-ready') === VERSION) return;
    root.setAttribute('data-contact-runtime-ready', VERSION);
    root.setAttribute('data-contact-runtime-owner', 'assets/glg-route-intent.js');

    var params = readParams();
    var defaultMode = clean(root.getAttribute('data-contact-default-mode')).toLowerCase();
    var context = {
      source: params.get('source') || '',
      intent: params.get('intent') || '',
      requestedStage: params.get('stage') || params.get('category') || '',
      scenario: params.get('scenario') || params.get('scene') || params.get('service_lane') || '',
      serviceLane: params.get('service_lane') || '',
      caseId: params.get('case') || params.get('product') || '',
      recordId: opaque(params.get('record_id'))
    };

    context.propertyMode =
      defaultMode === 'property' ||
      context.source === 'glhk' ||
      context.source === 'gproperty' ||
      context.source === 'gproperty-assets' ||
      context.intent === 'property-service' ||
      context.intent === 'manual-verification';

    context.projectMode =
      !context.propertyMode &&
      (
        defaultMode === 'project' ||
        context.source === 'gproject-showcases' ||
        context.source === 'gcitypartners-review-brief' ||
        context.source === 'service-product' ||
        context.source === 'gtender-pro-product' ||
        context.source === 'gcitypartners' ||
        context.intent === 'project-enquiry' ||
        context.intent === 'professional-review' ||
        context.intent === 'spatial-survey-review'
      );

    if (context.propertyMode) {
      context.source = context.source || 'glhk';
      context.intent = context.intent || 'property-service';
    }

    var choices = toArray(root.querySelectorAll('[data-contact-choice]'));
    var categoryNode = root.querySelector('[data-contact-category]');
    var sets = contactChoiceSets();
    var items = context.propertyMode
      ? sets.property
      : (context.projectMode ? sets.project : sets.support);

    var hydratedBrief = null;
    if (context.projectMode && context.source === 'gcitypartners-review-brief') {
      hydratedBrief = hydrateGCityPartnersBriefContext(root, context);
    }

    setContactModeContent(root, context.projectMode, context.propertyMode, context);
    hydratePropertyContext(root, context);
    renderContactChoices(choices, items, categoryNode);

    var initial = context.requestedStage || (
      context.propertyMode
        ? 'manual-verification'
        : (context.projectMode ? 'survey' : 'usage')
    );
    var initialButton = choices.find(function (button) {
      return button.getAttribute('data-contact-choice') === initial || button.getAttribute('data-contact-value') === initial;
    }) || choices[0];

    activateContactChoice(root, choices, initialButton, context, true);
    streamlineUavProjectContact(root, hydratedBrief);

    choices.forEach(function (button) {
      button.addEventListener('click', function () {
        activateContactChoice(root, choices, button, context, false);
      });
    });

    if (categoryNode && categoryNode.tagName === 'SELECT') {
      categoryNode.addEventListener('change', function () {
        var matched = choices.find(function (button) {
          return button.getAttribute('data-contact-value') === categoryNode.value;
        });
        if (matched) activateContactChoice(root, choices, matched, context, true);
      });
    }

    // Pending state only: Shopify's native response owns success and errors.
    var contactForm = root.querySelector('.contact-portal__form');
    if (contactForm) {
      contactForm.addEventListener('submit', function (event) {
        if (event.defaultPrevented || root.getAttribute('data-contact-mode') !== 'support') return;
        if (typeof contactForm.checkValidity === 'function' && !contactForm.checkValidity()) return;
        var language = String(document.documentElement.lang || '').toLowerCase();
        var pending = /^zh-(cn|hans|sg)(?:-|$)/.test(language)
          ? '正在提交…'
          : (/^zh(?:-|$)/.test(language) ? '正在送出…' : 'Sending…');
        setContactText(root, '[data-contact-submit]', pending);
      });
    }

    // B01-FOCUS: a deep-linked project enquiry focuses the existing form,
    // without opening the mobile keyboard or overriding an active user focus.
    if (context.projectMode && window.location.hash === '#contact-portal-form') {
      var projectForm = root.querySelector('.contact-portal__form');
      if (projectForm) {
        projectForm.setAttribute('tabindex', '-1');
        var focusProjectForm = function () {
          if (!root.isConnected || window.location.hash !== '#contact-portal-form') return;
          if (document.activeElement && document.activeElement !== document.body) return;
          try {
            projectForm.focus({ preventScroll: true });
          } catch (_error) {
            projectForm.focus();
          }
        };
        if (window.requestAnimationFrame) window.requestAnimationFrame(focusProjectForm);
        else focusProjectForm();
      }
    }
  }

  function boot(scope) {
    var base = scope || document;
    if (base.matches && base.matches(ROUTE_ROOT_SELECTOR)) mountRouteIntent(base);
    if (base.matches && base.matches(CONTACT_ROOT_SELECTOR)) mountContact(base);
    if (!base.querySelectorAll) return;
    toArray(base.querySelectorAll(ROUTE_ROOT_SELECTOR)).forEach(mountRouteIntent);
    toArray(base.querySelectorAll(CONTACT_ROOT_SELECTOR)).forEach(mountContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event && event.target ? event.target : document);
  });

  window.addEventListener('gcitypartners:review-brief:saved', function (event) {
    var detail = event && event.detail || {};
    if (
      !opaque(detail.record_id) ||
      detail.formal_submission_status !== 'not_submitted'
    ) return;

    toArray(document.querySelectorAll(CONTACT_ROOT_SELECTOR)).forEach(function (root) {
      if (root.getAttribute('data-contact-default-mode') !== 'project' || root.getAttribute('data-contact-mode') !== 'project') return;
      var context = {
        source: 'gcitypartners-review-brief',
        intent: 'professional-review',
        requestedStage: clean(detail.precheck_type) === 'uav-3d'
          ? 'survey'
          : '',
        scenario: clean(detail.service_lane),
        serviceLane: clean(detail.service_lane),
        caseId: '',
        recordId: opaque(detail.record_id),
        propertyMode: false,
        projectMode: true
      };

      var draft = hydrateGCityPartnersBriefContext(root, context);
      if (!draft) return;

      setContactModeContent(root, true, false, context);
      var choices = toArray(root.querySelectorAll('[data-contact-choice]'));
      renderContactChoices(choices, contactChoiceSets().project, root.querySelector('[data-contact-category]'));
      var selected = choices.find(function (button) {
        return button.getAttribute('data-contact-choice') === context.requestedStage;
      }) || choices[0];
      activateContactChoice(root, choices, selected, context, true);
      if (clean(detail.precheck_type) !== 'uav-3d') return;

      streamlineUavProjectContact(root, draft);

      var form = root.querySelector('.contact-portal__form');
      var firstContact = root.querySelector('[name="contact[name]"]');
      if (form) {
        try {
          form.scrollIntoView({ block: 'start', behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } catch (_error) {
          form.scrollIntoView();
        }
      }
      if (firstContact && typeof firstContact.focus === 'function') {
        window.setTimeout(function () {
          firstContact.focus({ preventScroll: true });
        }, 280);
      }
    });
  });

  window.GLGRouteIntent = {
    version: VERSION,
    init: boot
  };
})();
